import { isStringEmpty, checkIsProductNameValid } from 'utils/utils';

//it returns true if there's no error
export const validateFields = (
  fieldName,
  fieldValue,
  fieldDescription,
  descriptionValue,
  handleError
) => {
  const isEmptyValue = isStringEmpty(fieldValue);
  if (isEmptyValue) {
    handleError(fieldName, `Please enter  ${fieldName}`);
  }
  const isEmptyDescriptionValue = isStringEmpty(descriptionValue);
  console.log(isEmptyDescriptionValue, descriptionValue, fieldDescription, '431:description value');
  if (isEmptyDescriptionValue) {
    handleError(fieldDescription, `Please enter  ${fieldDescription}`);
  }

  const nameCheck = checkIsProductNameValid(fieldValue);
  if (nameCheck) {
    handleError(fieldName, `Please do not use special characters in name ${fieldName}`);
  }

  if (!isEmptyValue && !nameCheck && !isEmptyDescriptionValue) {
    return true;
  }
  return false;
};
